import * as Sentry from '@sentry/browser'
import { useContext, useEffect } from 'react'
import { AppContext } from 'contexts/AppProvider'
import { getLiff } from 'helpers/liff'
import { changeLanguage } from 'i18next'
import { setUserProppertyLanguage } from 'helpers/analytics'
import { LiffUser } from 'types'
import { useUpdateLineEmailCurrentUserMutation } from 'graphQL/hatostore/generate/operations'
import { serviceEndpoints } from 'variables/services'

const { liffAPI } = serviceEndpoints

interface useCurrentUserProps {
  currentUserData?: LiffUser | string
  handleIsNotLineFriend?: () => void
}

const liff = getLiff()
const useCurrentUser = ({ currentUserData, handleIsNotLineFriend }: useCurrentUserProps) => {
  const {
    currentUser,
    setCurrentUser,
    userEmail,
    lang,
    setLang,
    setInitialLang,
    setIsLineFriend,
    flagTriggerFetchCurrentUser,
    setFlagTriggerFetchCurrentUser,
    userProfile,
    isLiffInit,
  } = useContext(AppContext)

  const [updateLineEmailCurrentUser] = useUpdateLineEmailCurrentUserMutation({ context: { uri: liffAPI } })

  const _currentUser = currentUserData ? currentUserData : ''
  useEffect(() => {
    if (typeof _currentUser !== 'string' && (currentUser === '' || flagTriggerFetchCurrentUser)) {
      setCurrentUser(_currentUser)
      Sentry.setUser({
        id: `${_currentUser.id}`,
        username: userProfile.displayName,
        email: userEmail,
      })
      if (isLiffInit) {
        liff.getFriendship().then((data) => {
          if (data.friendFlag) {
            setIsLineFriend(data.friendFlag)
          } else {
            if (typeof handleIsNotLineFriend === 'function') {
              handleIsNotLineFriend()
            }
          }
        })
      }

      if (_currentUser.language) {
        setLang(_currentUser.language)
        changeLanguage(_currentUser.language)
        setUserProppertyLanguage({ lang: _currentUser.language })
      } else {
        setUserProppertyLanguage({ lang })
      }
      setInitialLang(true)

      if (_currentUser.lineEmail !== userEmail) {
        updateLineEmailCurrentUser({
          variables: { lineEmail: userEmail },
        }).then((res) => {
          if (res?.data?.updateCurrentUser) {
            setCurrentUser(res?.data?.updateCurrentUser)
          }
        })
      }

      flagTriggerFetchCurrentUser && setFlagTriggerFetchCurrentUser(false)
    }
  }, [_currentUser])
}

export default useCurrentUser
